import { makeGetRequest } from 'owa-ows-gateway';
import { GoDaddyDomainDetails } from '../contracts/GoDaddyDomainDetails';
import { format } from 'owa-string-utils';

const getdomainAuthCodeUrl: string = 'ows/api/beta/PremiumUser/authcode/?domainName={0}';

//Gets the authcode, locked status and privacy status
export async function getGoDaddyDomainDetails(domainName: string): Promise<GoDaddyDomainDetails> {
    let response = await makeGetRequest(format(getdomainAuthCodeUrl, domainName));
    return response;
}
